import { path } from 'rambda';
import { useTranslation } from 'react-i18next';
import PwaGuideImgRyuryuEN from '@/assets/images/brands/ryuryu/pwa-guide_en.png?format=avif;webp&as=picture';
import PwaGuideImgRyuryuVN from '@/assets/images/brands/ryuryu/pwa-guide_vn.png?format=avif;webp&as=picture';
import PwaGuideImgRyuryuCN from '@/assets/images/brands/ryuryu/pwa-guide_zh-cn.png?format=avif;webp&as=picture';
import PwaGuideImgRyuryuTW from '@/assets/images/brands/ryuryu/pwa-guide_zh-tw.png?format=avif;webp&as=picture';
import PwaGuideImgWangyouEN from '@/assets/images/brands/wangyou/pwa-guide_en.png?format=avif;webp&as=picture';
import PwaGuideImgWangyouVN from '@/assets/images/brands/wangyou/pwa-guide_vn.png?format=avif;webp&as=picture';
import PwaGuideImgWangyouCN from '@/assets/images/brands/wangyou/pwa-guide_zh-cn.png?format=avif;webp&as=picture';
import PwaGuideImgWangyouTW from '@/assets/images/brands/wangyou/pwa-guide_zh-tw.png?format=avif;webp&as=picture';
import PicturizedImage from '@/components/common/picturized-image';
import { useBrand } from '@/hooks/pwa/use-brand';
import type { BrandKey } from '@/models/configuration';
import { transformLanguageCode } from '@/utils/language-code';

const pictures: Record<BrandKey, Record<string, Picture>> = {
  ryuryu: {
    'zh-CN': PwaGuideImgRyuryuCN,
    'zh-TW': PwaGuideImgRyuryuTW,
    'en-US': PwaGuideImgRyuryuEN,
    'vi-VN': PwaGuideImgRyuryuVN,
  },
  wangyou: {
    'zh-CN': PwaGuideImgWangyouCN,
    'zh-TW': PwaGuideImgWangyouTW,
    'en-US': PwaGuideImgWangyouEN,
    'vi-VN': PwaGuideImgWangyouVN,
  },
};

export default function PwaGuideImage() {
  const { i18n } = useTranslation();
  const brand = useBrand();

  const resolvedLocale = transformLanguageCode(i18n.resolvedLanguage);
  const picture = path([brand.key ?? 'ryuryu', resolvedLocale], pictures);

  if (picture === undefined) return null;

  return <PicturizedImage picture={picture} />;
}
